import { Component } from 'vue';

import PatternProducts from '@/components/PatternProducts/PatternProductsList.vue';
import { createCoreVueApp } from '@/entrypoints/shared/core-vue-app';
import { mountProductTab } from '@/entrypoints/shared/tab-mounter';
import { PatternProduct } from '@/shared/composables/patternProducts/patternProducts.types';
import { contextualError } from '@/shared/utils/error';

const mountSelector = '#pattern-tab-products';
const boundTabSelector = '#tab-buy-here';

const getProps = () => {
  const target = document.querySelector<HTMLElement>(mountSelector);

  if (!target)
    throw contextualError('pattern-products', `Element "${target}" not found.`);

  const { patternId, defaultPatternProducts } = target.dataset;
  if (!defaultPatternProducts) return {};

  const patternProducts = JSON.parse(defaultPatternProducts);

  return {
    patternId,
    defaultPatternProductsList: patternProducts.filter(
      (pp: PatternProduct) => pp.product_id && pp.variant_id
    )
  };
};

const mounter = async (
  component: Component,
  target: HTMLElement,
  props?: Record<string, unknown>
) => {
  const coreApp = await createCoreVueApp(component, target, props);
  coreApp.mount(target);
};

mountProductTab(
  PatternProducts,
  mountSelector,
  boundTabSelector,
  mounter,
  getProps()
);
